import { FiCheck } from "react-icons/fi";
import { isValidVenue } from "~/utils/event";
import { SystemMessage } from "~/components/v4/themed/SystemMessage";
import { usePermissionsContext } from "~/app/providers";
import { Prisma } from "@prisma/client";
import { Button } from "~/components/v4/themed/Button";
import { confirmVenue } from "./actions";

export const InvalidVenueNotice = ({
    event,
}: {
    event: Prisma.EventGetPayload<{
        select: {
            id: true;
            googleMapsPlaceTypes: true;
            hostHasConfirmedIsValidLocation: true;
            isVirtual: true;
            location: true;
        };
    }>;
}) => {
    const { isManager, isAdmin, isHost } = usePermissionsContext();

    if (!isManager && !isAdmin && !isHost) return false;
    if (
        isValidVenue({
            ...event,
            googleMapsPlaceTypes: event.googleMapsPlaceTypes || [],
        })
    )
        return false;

    const handleConfirmVenue = async () => {
        await confirmVenue({ eventId: event.id });
    };

    return (
        <>
            <SystemMessage
                title="Invalid venue"
                status="warning"
                message={`
                    The specified address does not seem to point to a venue. Change the location above or press the button below to confirm that ${
                        !!event.location ? event.location : "this"
                    } is the correct location.
                    `}
                footer={
                    <>
                        <Button
                            variant="secondary"
                            className="hidden h-[30px] py-1 lg:flex"
                            onClick={handleConfirmVenue}
                        >
                            <FiCheck className="h-4 w-4" />
                            Confirm event venue location
                        </Button>
                        <Button
                            variant="secondary"
                            className="flex h-[30px] py-1 lg:hidden"
                            onClick={handleConfirmVenue}
                        >
                            <FiCheck className="h-4 w-4" />
                            Confirm
                        </Button>
                    </>
                }
            />
        </>
    );
};
